<template>
  <div>
    <div class="echart-main">
      <div class="echart-name">{{ chartData.yName }}</div>
      <div class="echart-box" :id="chartData.id" :style="chartData.height" />
    </div>
    <div class="line-result line-result-top" v-if="rightResult && leftResult">您当前{{ rightResult }}<br/>{{ leftResult }}</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      chartData: {},
      leftResult: '',
      rightResult: '',
    }
  },
  methods: {
    getMax(data, config) {
      let xMax = config.xMax;
      let yMax = config.yMax;
      let yMin = config.yMin;
      data.forEach(item => {
        if(item && item[0] && Number(item[0]) > xMax) xMax = Number(item[0])
        if(item && item[1] && Number(item[1]) > yMax) yMax = Number(item[1])
        if(item && item[1] && Number(item[1]) < yMin) yMin = Number(item[1])
      })
      return {
        xMax: Math.ceil(xMax),
        yMax: Math.ceil(yMax),
        yMin: Math.floor(yMin-1)

      };
    },
    onInit(chartData, leftResult, rightResult) {
      console.log(chartData);
      let allPointData = [...chartData.leftData, ...chartData.rightData];


      let maxConfig = this.getMax(allPointData, {
        xMax: chartData.xMax,
        yMax: chartData.yMax,
        yMin: chartData.yMin
      });

      if (leftResult && leftResult.indexOf('，') >= 0) {
        leftResult = leftResult.substring(0, leftResult.indexOf('，'));
        leftResult = leftResult.replace(/您当前/ig, '');
        leftResult = leftResult.replace(/。/ig, '');
      }
      
     
      if (rightResult && rightResult.indexOf('，') >= 0) {
        rightResult = rightResult.substring(0, rightResult.indexOf('，'));
        rightResult = rightResult.replace(/您当前/ig, '');
        rightResult = rightResult.replace(/。/ig, '');
      }
      
      this.leftResult = leftResult;
      this.rightResult = rightResult;
      this.chartData = chartData;
      const _this = this;
      setTimeout(() => {
        const myChart = _this.$echarts.init(document.getElementById(this.chartData.id));
        const series = [];
        this.chartData.yData.forEach((item, index) => {
          series.push({
            data: item,
            type: 'line',
            smooth: true,
            connectNulls: true,
            symbolSize: 0,
            lineStyle: {
              color: this.chartData.colors[index],
              width: 2
            },
            markPoint: {
              data: [
                { type: this.chartData.pointType==1?'min':'max', name: this.chartData.yNames[index] }
              ],
              symbol: 'circle', 
              symbolSize: 1, 

              label: {
                show: true,
                formatter: '{b}', // 显示标记点名称和值
                position: 'right', // 标签位置在上方
                offset: [0, index * 7],
                // position: [40, 0],
                color: '#999', // 标签文字颜色为黑色
                fontSize: '12px'
              }
            }
          })
        })
        //smooth: 1.5, 
        series.push({ name: "左眼", type: 'line', data: this.chartData.leftData, 
            color: '#59C067', connectNulls: true, 
            symbolSize: 10, label: { show: false, position: 'top' }, 
            areaStyle: {
                origin: 'start',
                color: {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                        { offset: 0, color: 'rgba(89, 192, 103, 0.3)' },
                        { offset: 1, color: 'rgba(89, 192, 103, 0.02)' }
                    ],
                    global: false
                },
                
            }, 
            itemStyle: {
              borderWidth: 2,    // 边框宽度，值越大线条越粗
            },
            smooth: true,
          })
        series.push({
          name: "右眼",
          type: 'line',
          smooth: true, // 确保smooth在根级别
          data: this.chartData.rightData,
          // symbol: 'circle', // 明确指定标记类型
          symbolSize: 10,
          showSymbol: true, // 默认不显示标记，只在悬停时显示
          label: {
              show: false,
              position: 'bottom'
          },
          itemStyle: {
              color: '#39A6F1', // 设置标记点的颜色
              borderWidth: 2,
          },
          lineStyle: {
              width: 2, // 设置线条宽度
              color: '#39A6F1' // 设置线条颜色
          },
          areaStyle: {
              origin: 'start',
              color: {
                  type: 'linear',
                  x: 0, y: 0, x2: 0, y2: 1,
                  colorStops: [
                      { offset: 0, color: 'rgba(89, 192, 103, 0.3)' },
                        { offset: 1, color: 'rgba(89, 192, 103, 0.02)' }
                  ],
                  global: false
              }
          }
      });
        const option = {
          grid: {
            left: '12%',  // 增加左侧间距（默认10%）
            bottom: '15%',
            right: '15%',
          },
          legend: {
            icon: 'path://M0,7 L20,7 A3,3 0 0 1 23,10 L23,17 A3,3 0 0 1 20,20 L0,20 A3,3 0 0 1 -3,17 L-3,10 A3,3 0 0 1 0,7 Z',
            itemWidth: 20,  // 长方形宽度
            itemHeight: 16, // 长方形高度
            // 可根据需要调整其他样式
            itemGap: 15,    // 图例项之间的距离
            textStyle: {
                fontSize: 12
            },
            show: true,
            right: '5%',
            top: this.chartData.yTop,
            data: [
              { name: "右眼" },
              { name: "左眼" }
            ]
          },
          tooltip: {
          trigger: 'axis',
            //  formatter 函数，自定义提示框内容
            formatter: function (params) {
                // 处理 x 轴数据，把单纯数字转成 “数字 + 岁”
                let result = `${params[0].axisValue} 岁<br/>`;
                params.filter(item => item.seriesName == '左眼' || item.seriesName == '右眼').forEach((item) => {
                    result += `${item.marker} ${item.seriesName}: ${item.value[1]}<br/>`;
                });
                return result;
            }
          },
          xAxis: {
            min: this.chartData.xMin,
            max: maxConfig.xMax,
            interval: 1,
            name: '年龄',
            // nameLocation: 'bottom',
            nameTextStyle: {
              color: '#666',
              // padding: this.chartData.padding
            },
            axisLabel: {
              color: '#666'
            },
            axisLine: {
              onZero: false, // 关键配置：x 轴不与 y=0 绑定
              lineStyle: {
                color: '#ccc',
                width: 1,
                type: 'dashed'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: '#ddd'
              }
            }
          },
          yAxis: {
            min: maxConfig.yMin,
            interval: 1,
            max: maxConfig.yMax,
            name: this.chartData.id == 'chat' ? '单位：D' : '单位：mm',
            nameTextStyle: {
              color: '#666'
            },
            axisLabel: {
              color: '#666',
              formatter: function (value) {
                if (chartData.id == 'chat') {
                  return value.toFixed(2);
                }
                return value;
              }
            },
            axisLine: {
              lineStyle: {
                color: '#ccc',
                width: 1,
                type: 'dashed'
              }
            },

            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: '#ddd'
              }
            }
          },
          series
        };
        myChart.setOption(option);
      }, 500);
    }
  }
}
</script>
<style lang="less" scoped>
.echart-main {
  display: flex;
  .echart-name {
    width: 1.5em;
    margin-top: 2rem;
    margin-right: 0.2rem;
    font-size: 0.28rem;
    text-align: center;
  }
  .echart-box {
    width: 6.2rem;
    height: 400px;
  }
}

.echart-result {
  width: 6.5rem;
  padding: 0.3rem;
  text-align: left;
}
.line-result {
  width: 100%;
    /* padding: 0.05rem 12vw 0.3rem; */
    line-height: 0.46rem;
    font-size: 0.27rem;
    text-align: left;
    padding: 0 3vw;
    box-sizing: border-box;
}
.line-result-top {
  padding: 0 6.4vw;
}
</style>